// import 'bootstrap';
import './sass/main.scss';
// import './../node_modules/slick-carousel/slick/slick.scss';
import './../node_modules/slicknav/scss/slicknav.scss';
import './../node_modules/slicknav/scss/core.scss';
import './../node_modules/slicknav/scss/theme.scss';
// import './../node_modules/aos/src/sass/aos.scss';

import Chocolat from 'chocolat';

const $ = require('jquery');
// const slick = require('slick-carousel');
const slicknav = require('slicknav/jquery.slicknav');
const waypoints = require('././../node_modules/waypoints/lib/jquery.waypoints');
// const Parallax = require('parallax-js');
// const AOS = require('aos');

//AOS.init();

$('#menu').slicknav();

Chocolat(document.querySelectorAll('.chocolat-image'), {
	loop: true,
	imageSize: 'contain',
});